import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card, CardHeader } from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import { red400, indigo500, grey300 } from 'material-ui/styles/colors';

const Loader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 200px);
`;

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Title = styled.h2`
    flex-grow: 1;
    color: ${indigo500};
    font-weight: inherit;

    svg {
        margin-right: 10px;
        transform: translate(0, 4px);
    }
`;

const ButtonWrapper = styled.div`
    display: inline-block;
    text-align: right;

    button {
        color: #fff;
    }

    > * + * {
        margin-left: 20px;
    }
`;

const ErrorText = styled.h3`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: ${red400};
`;

const CardHeaderStyle = {
    borderBottom: `1px solid ${grey300}`,
    paddingTop: 0,
    paddingBottom: 0
};

const IconPacksStyle = {
    color: 'inherit'
};

const CardStyle = {
    marginBottom: 15
};

function PageCardWrapper({
    IconHeader,
    title = '',
    buttonsAction,
    isError = false,
    errorText = '',
    isFinished = false,
    children
}) {
    return (
        <div>
            <Card style={CardStyle}>
                <CardHeader style={CardHeaderStyle}>
                    <HeaderWrapper>
                        <Title>
                            {IconHeader && <IconHeader style={IconPacksStyle} />}
                            {title}
                        </Title>
                        {buttonsAction && <ButtonWrapper>{buttonsAction}</ButtonWrapper>}
                    </HeaderWrapper>
                </CardHeader>
                {isFinished && isError && <ErrorText>{errorText}</ErrorText>}
                {!isFinished && (
                    <Loader>
                        <CircularProgress size={80} thickness={5} />
                    </Loader>
                )}
                {isFinished && !isError && children}
            </Card>
        </div>
    );
}

PageCardWrapper.propTypes = {
    IconHeader: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    title: PropTypes.string,
    buttonsAction: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    isError: PropTypes.bool,
    errorText: PropTypes.string,
    isFinished: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired])
};

export default PageCardWrapper;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/PageCardWrapper.js
 **/